import { SuportAreaTranslations } from "./suport-area-pt-br";

export const SUPORT_AREA_FR_FR: SuportAreaTranslations = {
	title: "Centre d'aide",
	questionTitle: "Besoin d'aide ?",
	questionDescription: "Ouvrez un ticket et parlez à notre équipe de support.",
	openTicket: "Nouveau ticket",
	close: "Fermer",
};
